module.exports = __webpack_public_path__ + "img/condo.553eca8a.jpg";